export default __webpack_public_path__ + "static/media/Slide19.81bcc097.JPG";